module.exports = __webpack_public_path__ + "static/desktop/img/custom-intro-cn.519e9e18.png";